import Vue from 'vue'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import iView from 'view-design'
import 'view-design/dist/styles/iview.css'
import App from './app.vue'
import util from './libs/util'
import router from './router/router'
import store from './store/store'
// import VueI18n from 'vue-i18n'
// import localeI18n from './i18n/index'
import {
  Backtop,
  Button,
  Calendar,
  Card,
  Carousel,
  CarouselItem,
  Cascader,
  Checkbox,
  CheckboxGroup,
  Col,
  DatePicker,
  Descriptions,
  DescriptionsItem,
  Dialog,
  Drawer,
  FormItem,
  Image,
  Input,
  Message,
  MessageBox,
  Option,
  Pagination,
  Popover,
  Radio,
  RadioGroup,
  Rate,
  Row,
  Select,
  Step,
  Steps,
  Table,
  TableColumn,
  TabPane,
  Tabs,
  Tag,
  Tree,
  Upload
} from 'element-ui';
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';
import JsEncrypt from 'jsencrypt' /*公钥 */
import './assets/css/public.css' /*通用样式 */
import moment from 'moment' // 导入文件
import BaiduMap from 'vue-baidu-map'
import echarts from "echarts";
import Print from './libs/print.js'

Vue.prototype.$echarts = echarts;
Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: '8H2p9RPTrNBr3GctRrYWOAhenmdK8FuY'
})

Vue.use(Print)
Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999,
    loading: false
  }
})

Vue.config.productionTip = false
Vue.prototype.$util = util
Vue.prototype.$http = util.http
Vue.prototype.$getImg = util.getImg
Vue.prototype.$getImgUrl = process.env.VUE_APP_IMG_URL
Vue.prototype.$getImgFile = process.env.VUE_APP_File_URL
Vue.prototype.$moment = moment //赋值使用
Vue.prototype.$bus = new Vue();
Vue.prototype.$encruption = function (obj, key) {
  let encrypt = new JsEncrypt()
  // 公钥
  encrypt.setPublicKey(
    key
  )
  return encrypt.encrypt(obj)
}

// Vue.use(VueI18n)

Vue.use(Pagination)
Vue.use(Tree)
Vue.use(Image)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Calendar)
Vue.use(TabPane)
Vue.use(Tabs)
Vue.use(DescriptionsItem)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(Descriptions)
Vue.use(Tag)
Vue.use(Popover)
Vue.use(DatePicker)
Vue.use(Button)
Vue.use(Steps)
Vue.use(Step)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Select)
Vue.use(Option)
Vue.use(Card)
Vue.use(Cascader)
Vue.use(Upload)
Vue.use(Dialog)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Drawer)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Backtop)
Vue.use(Row)
Vue.use(Col)
Vue.use(Rate)
Vue.component(CollapseTransition.name, CollapseTransition)


Vue.prototype.$message = Message;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirmss = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;

Vue.use(iView)

Vue.prototype.setCookie = function (name, value, day) {
  if (day !== 0) {
    const expires = day * 24 * 60 * 60 * 1000;
    const date = new Date(+new Date() + expires);
    document.cookie = name + "=" + escape(JSON.stringify(value)) + ";expires=" + date.toUTCString();
  } else {
    document.cookie = name + "=" + escape(JSON.stringify(value));
  }
};

//获取cookie
Vue.prototype.getCookie = function (name) {
  let arr;
  const reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if (arr === document.cookie.match(reg))
    return JSON.parse(unescape(arr[2]));
  else
    return null
};


Vue.locale = () => {
}

// const i18n = new VueI18n(localeI18n)

const vm = new Vue({
  router,
  store,
  // i18n,
  render: h => h(App)
}).$mount('#app')

export default vm
